import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { GetStaticProps } from 'next';
import { MinimalFooter } from '@zola/zola-ui/src/components/MinimalFooter';
import { MinimalHeader } from '@zola/zola-ui/src/components/MinimalHeader';

import { loginCallback } from '~/libs/client/account/login/loginHelpers';

const AuthForms = dynamic(import('@zola/zola-ui/src/components/AuthForms'), {
  ssr: false,
});

const AccountLogin: React.FC = () => {
  return (
    <>
      <Head>
        <title>Account Login - Zola</title>
      </Head>
      <MinimalHeader />
      <main>
        <AuthForms
          loginCallback={loginCallback}
          signupLinkCallback={() => {
            window.location.href = '/onboard/new';
            return false;
          }}
        />
      </main>
      <MinimalFooter position="fixed" />
    </>
  );
};

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default AccountLogin;
